import { Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import Loader from "../components/Loader";
import { useState } from "react";
import { useUpdateGymPaymentByAdminMutation } from "../slices/gymPaymentSlice";

const UpdatePaymentsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const location = useLocation();
  const { gymDetails } = location.state || {};
  const [paidAmount, setPaidAmount] = useState();
  const [transactionId, setTransactionId] = useState();
  const navigate = useNavigate();

  const [updatePayment, { isLoading }] = useUpdateGymPaymentByAdminMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      !paidAmount ||
      Number(paidAmount) <= 0 ||
      Number(paidAmount) > Number(gymDetails.dueAmount)
    ) {
      toast.error(
        "Paid amount should be greater than 0 and less than due amount"
      );
      return;
    }

    try {
      const payload = {
        gymId: gymDetails?._id,
        paidAmount: paidAmount,
        transactionId: transactionId,
      };
      const res = await updatePayment({
        payload: payload,
        token: userInfo?.token,
      }).unwrap();
      if (res) toast.success("Gym Payment Updated Successfully");
      // navigate(redirect);
      navigate("/pendingPayments");
    } catch (err) {
      toast.error(err?.data?.error || err.error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
        width: "100%",
      }}
    >
      <h6 style={{ color: "green" }}>Update Gym Payment</h6>
      <Form.Group className="my-2" controlId="gymId">
        <Form.Control
          type="text"
          pattern="[0-9]*" // Allow only digits
          value={gymDetails?._id || ""}
          disabled={true}
        />
      </Form.Group>
      <Form.Group className="my-2" controlId="gymName">
        <Form.Control
          type="text"
          value={gymDetails?.name || ""}
          disabled={true}
        />
      </Form.Group>

      <Form.Group className="my-2" controlId="pendingAmount">
        <div style={{ display: "flex" }}>
          <InputGroup>
            <Form.Control
              disabled="true"
              type="text"
              placeholder="Pending Amount"
              value={gymDetails.dueAmount}
            />
          </InputGroup>
        </div>
      </Form.Group>

      <Form.Group className="my-2" controlId="paidAmount">
        <div style={{ display: "flex" }}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Paid Amount"
              value={paidAmount}
              onChange={(e) => setPaidAmount(e.target.value)}
            />
          </InputGroup>
        </div>
      </Form.Group>
      <Form.Group className="my-2" controlId="transactionId">
        <div style={{ display: "flex" }}>
          <InputGroup>
            {" "}
            <Form.Control
              type="text"
              placeholder="Transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
            />
          </InputGroup>
        </div>
      </Form.Group>

      <Button
        type="submit"
        variant="primary"
        style={{ marginTop: "1rem", background: "green" }}
        onClick={submitHandler}
      >
        Submit
      </Button>
      {isLoading && <Loader />}
    </div>
  );
};

export default UpdatePaymentsScreen;
